export const subtractNMonths = (n: number) => {
  const date = new Date();
  date.setMonth(date.getMonth() - n);
  return date;
};
